import { useContext } from "react";
import NotificationsContext from "Services/NotificationProvider";

const useNotifications = () => {
    return useContext(NotificationsContext);
};

export default useNotifications;
